import { NotificationChannel } from '@/core/notifications/model';

export function isContactFormValid(
  channel: NotificationChannel | undefined,
  fieldValues: Record<string, string>,
): boolean {
  if (!channel) return false;
  return !channel.configFields.some(field => field.required && !fieldValues[field.key]?.trim());
}

export function buildContactConfig(
  channel: NotificationChannel,
  fieldValues: Record<string, string>,
): Record<string, string> {
  const config: Record<string, string> = {};
  channel.configFields.forEach(field => {
    const value = fieldValues[field.key]?.trim();
    if (value) config[field.key] = value;
  });
  return config;
}
